import "./Home.scss";
import Card from "../CommonUIComponents/Card/Card";
import { CardList } from "./CardList";
import { useI18n } from "../../hooks/useI18n";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMemo, useEffect } from "react";
import { setVisitedHome } from "../../store/slices/landingPageSlice";
import { isGlobalReporting, normalizeRoles } from "../../util/roleHelpers";

function Home() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roleData = useSelector((state) => state.landing.roleData);

  useEffect(() => {
    dispatch(setVisitedHome());
  }, [dispatch]);

  const roles = useMemo(() => normalizeRoles(roleData?.role), [roleData]);

  const coeLabel = useMemo(() => roleData?.coe || "", [roleData]);

  const isRoleReady = roles.length > 0;
  const isCoeReady = Boolean(coeLabel);
  const isAccessReady = isRoleReady || isCoeReady;

  const handleViewOrder = ({ domain }) => {
    if (isAccessReady && domain) {
      navigate(`/${domain}`);
    }
  };

  const filteredCardList = useMemo(() => CardList, []);
  const backgroundVideo = "/homePageBackground.mp4";

  return (
    <>
      <main className="home">
        <video
          className="home-video-background"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={backgroundVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="video-overlay"></div>

        <article>
          <p className="motif-display-default-regular">{t("apptitle")}</p>
          <p className="motif-h3-default-light">{t("appdescription")}</p>
        </article>
        <section>
          {filteredCardList.map((card) => (
            <Card
              key={card.id}
              domain={card.domain}
              cardHeader={card.header}
              cardBody={card.body}
              isAccessReady={isAccessReady}
              onViewOrder={handleViewOrder}
              //enable the below condition for coe based routing
              // isCoeMatched={card.domain === coeLabel}
              isCoeMatched={true}
            />
          ))}
        </section>
      </main>
    </>
  );
}

export default Home;
